// extracted by mini-css-extract-plugin
module.exports = {"hourLegend":"SystemDailyHourDeal_hourLegend__3QICB","active":"SystemDailyHourDeal_active__BkJVs","square":"SystemDailyHourDeal_square__3vQSE"};